import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetRecentlyViewedReports as GetRecentlyViewedReportsQuery,
    GetRecentlyViewedReports_recentlyViewedReports as RecentlyViewedReports,
} from 'nutshell-graphql-types';

import GET_RECENTLY_VIEWED_REPORTS from '../queries/get-recently-viewed-reports.graphql';

export const useGetRecentlyViewedReports = (): {
    recentlyViewedReports: RecentlyViewedReports[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetRecentlyViewedReportsQuery,
        Record<any, any>
    >(GET_RECENTLY_VIEWED_REPORTS, {fetchPolicy: 'cache-and-network'});

    return {
        recentlyViewedReports: (data && data.recentlyViewedReports) || [],
        isLoading: loading && !data,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
